<video
  #videoElement
  data-test="video-preview"
  class="rounded w-100"
  floMse
  playsinline
  [poster]="posterImage"
  [muted]="true"
  [src]="src"
  (floMseClientMessageChange)="handleHlsMessages$.next($event)"
>
</video>
